const upperCaseString = (string) => {
  return string.toUpperCase();
};

export default upperCaseString;
